module.exports = "/assets/data/b6719f23d020b27539c99e478892222a-LS12.data.json";